import Vue from 'vue';
import accountService from './../account';
import store from './../../store';

export default (token) => {
  store.dispatch('login', token);
  localStorage.setItem('is_admin', true);
  accountService.find().then(() => {
    Vue.router.push({
      name: 'dashboard',
    });
  });
};



// WEBPACK FOOTER //
// ./src/app/services/auth/loginUsingToken.js